"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReminderUser_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReminderUser_Factory = /** @class */ (function () {
    function ReminderUser_Factory() {
    }
    ReminderUser_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ReminderId: model.ReminderId,
            UserId: model.UserId,
        };
        return result;
    };
    ReminderUser_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ReminderId: model.ReminderId,
            UserId: model.UserId,
        };
        return result;
    };
    return ReminderUser_Factory;
}());
exports.ReminderUser_Factory = ReminderUser_Factory;
